import { render, staticRenderFns } from "./pic-carousel.vue?vue&type=template&id=1202ba81&scoped=true&"
import script from "./pic-carousel.vue?vue&type=script&lang=js&"
export * from "./pic-carousel.vue?vue&type=script&lang=js&"
import style0 from "./pic-carousel.vue?vue&type=style&index=0&id=1202ba81&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1202ba81",
  null
  
)

export default component.exports